import CreateSuggestionContainer from './CreateSuggestionContainer';
export default CreateSuggestionContainer;
